const SALES_ORDER_CREATED_EVENT = 'sales-order-created';

const salesOrderEventTarget: EventTarget = new EventTarget();

export interface SalesOrderCreatedDetail {
  documentSequenceCode?: string;
}

export const notifySalesOrderCreated = (
  detail: SalesOrderCreatedDetail = {}
) => {
  salesOrderEventTarget.dispatchEvent(
    new CustomEvent<SalesOrderCreatedDetail>(SALES_ORDER_CREATED_EVENT, {
      detail
    })
  );
};

export const subscribeSalesOrderCreated = (
  handler: (detail: SalesOrderCreatedDetail) => void
) => {
  const listener = (event: Event) => {
    const customEvent = event as CustomEvent<SalesOrderCreatedDetail>;
    handler(customEvent.detail ?? {});
  };
  salesOrderEventTarget.addEventListener(
    SALES_ORDER_CREATED_EVENT,
    listener as EventListener
  );
  return () => {
    salesOrderEventTarget.removeEventListener(
      SALES_ORDER_CREATED_EVENT,
      listener as EventListener
    );
  };
};
